import {
  Calendar,
  Drawer,
  Flexbox,
  Positions,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import dayjs from 'dayjs';
import type { DateSelectorProps } from 'pages/Optimisation/components/DateSelector/DateSelector.types';
import { useStore } from 'store';
import { styled } from 'styled-components';

const CalendarContainer = styled(Flexbox)``;

export const MobileCalendarDrawer = ({
  cellRender,
}: Pick<DateSelectorProps, 'cellRender'>) => {
  const [setMobileCalendarClosed, currentDate, setCurrentDate] = useStore(
    (state) => [
      state.setMobileCalendarClosed,
      state.currentDate,
      state.setCurrentDate,
    ],
  );

  return (
    <Drawer
      data-testid="mobile-company-drawer"
      header={{ title: 'Choose date' }}
      size={Sizes.Small}
      open
      placement={Positions.Bottom}
      onClose={setMobileCalendarClosed}
      mask
      elevation={true}
      padding={true}
      style={{ zIndex: '100' }}
    >
      <Flexbox justifyContent={'center'} style={{ marginTop: '-24px' }}>
        <Calendar
          size={Sizes.Large}
          onChange={(dateString) => setCurrentDate(dayjs(dateString).toDate())}
          showToday={true}
          value={dayjs(currentDate)}
          cellRender={cellRender}
        />
      </Flexbox>
    </Drawer>
  );
};
